import React, { useState } from 'react';
import { useNavigate, Outlet, useLocation } from 'react-router-dom';
import './ManagementLayout.css';

const ManagementLayout = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [sidebarOpen, setSidebarOpen] = useState(true);
  const [showQuickActions, setShowQuickActions] = useState(false);
  const user = JSON.parse(localStorage.getItem('user') || '{}');

  const handleSignOut = () => {
    localStorage.removeItem('user');
    localStorage.removeItem('token');
    navigate('/login');
  };

  const menuItems = [
    { path: '/management', label: 'Dashboard', exact: true },
    { path: '/management/orders', label: 'Orders' },
    { path: '/management/products', label: 'Products' },
    { path: '/management/grouping', label: 'Product Grouping' },
    { path: '/management/inventory', label: 'Inventory' },
    { path: '/management/customers', label: 'Customers' },
    { path: '/management/promotions', label: 'Promotions' },
    { path: '/management/collections', label: 'Collections' },
    { path: '/management/chat', label: 'Chat Support' },
    { path: '/management/discounts', label: 'Discounts' },
    { path: '/management/pricing', label: 'Price Update' },
    { path: '/management/best-sellers', label: 'Best Sellers' },
    { path: '/management/shipping', label: 'Shipping' },
    { path: '/management/content', label: 'Content' },
    ...(user.role === 'admin' ? [
      { path: '/management/staff', label: 'Staff' },
      { path: '/management/reports', label: 'Reports' },
      { path: '/management/settings', label: 'Settings' }
    ] : [])
  ];

  const isActive = (path, exact) => {
    if (exact) {
      return location.pathname === path;
    }
    return location.pathname.startsWith(path);
  };

  return (
    <div className="management-layout">
      {/* Sidebar */}
      <aside className={`management-sidebar ${sidebarOpen ? 'open' : 'closed'}`}>
        <div className="sidebar-header">
          <div className="sidebar-logo">
            <img src="/images/tc-nails-depot-logo.webp" alt="TC Nails" />
          </div>
          <button className="sidebar-toggle" onClick={() => setSidebarOpen(!sidebarOpen)}>
            {sidebarOpen ? '◀' : '▶'}
          </button>
        </div>

        <nav className="sidebar-nav">
          {menuItems.map((item) => (
            <button
              key={item.path}
              className={`nav-item ${isActive(item.path, item.exact) ? 'active' : ''}`}
              onClick={() => navigate(item.path)}
            >
              {sidebarOpen && <span className="nav-label">{item.label}</span>}
              {!sidebarOpen && <span className="nav-label-short">{item.label.charAt(0)}</span>}
            </button>
          ))}
        </nav>

        <div className="sidebar-footer">
          <div className="user-info">
            {sidebarOpen && (
              <>
                <div className="user-name">{user.firstName} {user.lastName}</div>
                <div className="user-role">{user.role}</div>
              </>
            )}
          </div>
          <button className="btn-signout" onClick={handleSignOut}>
            {sidebarOpen ? 'Sign Out' : 'Out'}
          </button>
        </div>
      </aside>

      {/* Main Content */}
      <main className="management-main">
        <div className="management-topbar">
          <h1 className="page-title">
            {menuItems.find(item => isActive(item.path, item.exact))?.label || 'Management'}
          </h1>
          <div className="topbar-actions">
            <div className="quick-actions-wrapper">
              <button 
                className="btn-quick-actions" 
                onClick={() => setShowQuickActions(!showQuickActions)}
              >
                + Quick Actions
              </button>
              {showQuickActions && (
                <div className="quick-actions-dropdown">
                  <button onClick={() => { navigate('/management/products/new'); setShowQuickActions(false); }}>
                    Add Product
                  </button>
                  <button onClick={() => { navigate('/management/orders'); setShowQuickActions(false); }}>
                    View Orders
                  </button>
                  <button onClick={() => { navigate('/management/discounts/new'); setShowQuickActions(false); }}>
                    Create Discount
                  </button>
                </div>
              )}
            </div>
            <button className="btn-view-site" onClick={() => window.open('/', '_blank')}>
              View Site
            </button>
          </div>
        </div>

        <div className="management-content">
          <Outlet />
        </div>
      </main>
    </div>
  );
};

export default ManagementLayout;
